import { useEffect, useState } from 'react';
import { useAuth, useLocale } from '../../context';
import { api } from '../../api';
import { IconRequestsEmpty, IconRequestsNew } from '../VurgunIcons';
import { formatSupportTicketStatus } from '../../utils/supportTicketStatus';
import '../../styles/requests.css';

function formatTicketDate(value) {
  const date = new Date(value);
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export default function MobileAccountRequests({ onGoHelp, onCreateRequest }) {
  const _locale = useLocale();
  const tr = _locale.t;
  const { token } = useAuth();
  const [tickets, setTickets] = useState([]);

  const loadTickets = () => {
    if (!token) return;
    api.supportTickets(token).then(setTickets).catch(() => setTickets([]));
  };

  useEffect(loadTickets, [token]);

  return (
    <div className="mobile-account-requests">
      <div className="mobile-account-requests__hero">
        <div className="mobile-account-requests__icon" aria-hidden="true">
          <IconRequestsEmpty />
        </div>
        <h2 className="mobile-account-requests__title">{tr('account.requests.mobile.title')}</h2>
        <p className="mobile-account-requests__desc">{tr('account.requests.mobile.desc')}</p>
        <div className="mobile-account-requests__actions">
          <button
            type="button"
            className="mobile-account-requests__btn mobile-account-requests__btn--primary"
            onClick={() => onCreateRequest?.()}
          >
            <span className="mobile-account-requests__btn-icon" aria-hidden="true">
              <IconRequestsNew />
            </span>
            <span>{tr('account.requests.mobile.create')}</span>
          </button>
          <button
            type="button"
            className="mobile-account-requests__btn mobile-account-requests__btn--secondary"
            onClick={() => onGoHelp?.()}
          >
            {tr('account.requests.mobile.helpCentre')}
          </button>
        </div>
      </div>

      {tickets.length > 0 && (
        <div className="mobile-account-requests__list">
          <h3 className="mobile-account-requests__list-title">{tr('account.support.history')}</h3>
          {tickets.map((ticket) => (
            <div key={ticket.id} className="mobile-account-requests__item">
              <div className="mobile-account-requests__item-subject">{ticket.subject}</div>
              <div className="mobile-account-requests__item-meta">
                <span>{formatTicketDate(ticket.created_at)}</span>
                <span>{formatSupportTicketStatus(tr, ticket.status)}</span>
              </div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
}
